const muiCores = {

//-------------------------------------------
// Cores Institucionais da VBI
//-------------------------------------------

    pretoVbi: {
        light: '#2c2c2c',
        main: '#000000',
        dark: '#000000',
        contrastText: '#fff',
    },

    cinzaVbi1: {
        light: '#909292',
        main: '#636464',
        dark: '#393a3a',
        contrastText: '#fff',
    },

    cinzaVbi2: {
        light: '#a6a7aa',
        main: '#77787b',
        dark: '#4b4c4f',
        contrastText: '#fff',
    },

    cinzaVbi3: {
        light: '#cacccf',
        main: '#999b9e',
        dark: '#6b6d70',
        contrastText: '#fff',
    },

    cinzaVbi4: {
        light: '#eeeff3',
        main: '#bcbdc0',
        dark: '#8c8d90',
        contrastText: '#fff',
    },

    cinzaVbi5: {
        light: '#ffffff',
        main: '#d1d3d4',
        dark: '#a0a2a3',
        contrastText: '#fff',
    },


//-------------------------------------------
// Cores de Apoio da VBI
//-------------------------------------------

    laranjaVbi1: {
        light: '#ffce53',
        main: '#f99d1c',
        dark: '#c06e00',
        contrastText: '#fff',
    },


    laranjaVbi2: {
        light: '#fff453',
        main: '#ffc20e',
        dark: '#c79200',
        contrastText: '#fff',
    },


    azulVbi1: {
        light: '#66e5ff',
        main: '#00b3f0',
        dark: '#0083bd',
        contrastText: '#fff',
    },


    azulVbi2: {
        light: '#a2acf0',
        main: '#717dbd',
        dark: '#41518d',
        contrastText: '#fff',
    },

    verdeVbi1: {
        light: '#58dbce',
        main: '#00a99d',
        dark: '#00796f',
        contrastText: '#fff',
    },

    verdeVbi2: {
        light: '#e8ff6a',
        main: '#b3d335',
        dark: '#80a200',
        contrastText: '#fff'
    },

//-------------------------------------------
// Outras Cores
//-------------------------------------------

    azulMaterialUi: {    
        light: '#4791db',
        main: '#1976d2',
        dark: '#115293',
        contrastText: '#fff',
    },  

    azulVbiFakeDark1: {
        light: '#4a83bd',
        main: '#00578d',
        dark: '#002f5f',
        contrastText: '#fff',
    },

    azulVbiFakeDark2: {
        light: '#927dff',
        main: '#5850ec',
        dark: '#0026b8',
        contrastText: '#fff',
    },    

    azulMidnightExpress: {
        light: '#342970',
        main: '#000044',
        dark: '#00001f',
        contrastText: '#fff'
    },


    azulExcelDarkBlue: {
        light: '#3e478e',
        main: '#002060',
        dark: '#000036',
        contrastText: '#fff'
    },


    azulExcelBlueGray: {
        light: '#708098',
        main: '#44546a',
        dark: '#1a2b3f',
        contrastText: '#fff',
        splitComplementaryColor: {
            light: '#959870',
            main: '#676a44',
            dark: '#3c3f1c',
            contrastText: '#fff'
        },   
    },

    azulExcelBlueGrayLighter40: {
        light: '#b4c8e2',
        main: '#8497b0',
        dark: '#566981',
        contrastText: '#fff'
    },    

    azulExcelBlueGrayLighter20: {
        light: '#8ca1c1',
        main: '#5d7391',
        dark: '#314863',
        contrastText: '#fff'
    },    

    azulWikipediaBlueGray: {
        light: '#98caff',
        main: '#6699cc',
        dark: '#326b9b',
        contrastText: '#fff'
    },    

    azulBlueGray2: {
        light: '#5b80ae',
        main: '#2a547e',
        dark: '#002c51',
        contrastText: '#fff',
        complementaryColor: {
            light: '#b08054',
            main: '#7e542a',
            dark: '#4e2b00',
            contrastText: '#fff'
        },
        splitComplementaryColor: {
            light: '#afad57',
            main: '#7e7e2a',
            dark: '#4f5200',
            contrastText: '#fff'
        },        
    },    

    azulAteneoBlue: {
        light: '#41659c',
        main: '#003b6d',
        dark: '#001641',
        contrastText: '#fff'
    }

}


export default muiCores